export type LogLevel = "debug" | "info" | "warn" | "error"

export type LogContext = Record<string, string | number | boolean | null | undefined>

type ConsoleMethod = (...data: unknown[]) => void

const consoleMethods: Record<LogLevel, ConsoleMethod> = {
  debug: (...data) => console.debug(...data),
  info: (...data) => console.info(...data),
  warn: (...data) => console.warn(...data),
  error: (...data) => console.error(...data),
}

function compactContext(context: LogContext = {}) {
  return Object.fromEntries(Object.entries(context).filter(([, value]) => value !== undefined))
}

export function logEvent(level: LogLevel, event: string, context: LogContext = {}) {
  consoleMethods[level](event, compactContext(context))
}
